export const INIT_FILE_MONITORING_DATA = 'INIT_FILE_MONITORING_DATA';
export const FETCH_EXISTING_RESULTS = 'FETCH_EXISTING_RESULTS';
export const FETCH_RESULTS = 'FETCH_RESULTS';
export const GET_FILE_MONITORING_HEADER_TO_DISPLAY = 'GET_FILE_MONITORING_HEADER_TO_DISPLAY';
export const GET_FILE_MONITORING_COLUMNS = 'GET_FILE_MONITORING_COLUMNS';
export const FM_SAVE_PARAMETERS = 'FM_SAVE_PARAMETERS';
export const FETCH_SEARCH_FILE_EVENT_FAILURE = 'FETCH_SEARCH_FILE_EVENT_FAILURE';
